import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum ClaimAction {
  CREATE_CLAIM = "CREATE_CLAIM",
  FETCH_CLAIM_INFO = "FETCH_CLAIM_INFO",
  DELETE_CLAIM_CREATE_NEW = "DELETE_CLAIM_CREATE_NEW",
  INSERT_CLAIM_ITEMS = "INSERT_CLAIM_ITEMS",
  REMOVE_CLAIM_ITEM = "REMOVE_CLAIM_ITEM",
  INSERT_CLAIM_ITEM_DAMGES = "INSERT_CLAIM_ITEM_DAMGES",
  SUBMIT_CLAIM = "SUBMIT_CLAIM",
  SET_CLAIM_ID_PLAN = "SET_CLAIM_ID_PLAN",
  SET_CLAIM_INFO = "SET_CLAIM_INFO",
  CLAIM_ITEM_FILE_UPLOAD = "CLAIM_ITEM_FILE_UPLOAD",
  CLAIM_ITEM_DELETE_DOCUMENT = "CLAIM_ITEM_DELETE_DOCUMENT",
  GET_CUSTOMER_INFO = "GET_CUSTOMER_INFO",
  UPDATE_CUSTOMER_INFO = "UPDATE_CUSTOMER_INFO",
  FETCH_WARRNTY_ITEMS = "FETCH_WARRNTY_ITEMS",
  DELETE_DAMAGE_ITEM = "DELETE_DAMAGE_ITEM",
  SET_WARRNTY_ITEMS = "SET_WARRNTY_ITEMS",
  CLEAN_UP = "CLEAN_UP_CLAIM_INFO",
}

export interface ClaimState {
  claimId: string;
  status: string;
  plan: {};
  customerId: string;
  warranty_items: [];
  claim_items: any[];
  damages: any[];
}

export type ClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const ClaimScope = "claim";
